module.exports = __webpack_public_path__ + "img/safari-compass.51eb798e.svg";